import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import SparkleIcon from '../icons/Sparkle';

// import * as AppPropTypes from '../../../lib/PropTypes';
import styles from '../../../styles/splashes/iga-noel-employees-splash.module.scss';

import branch from '../../../img/iga/noel/branch.png';
import calendar from '../../../img/iga/noel/header_calendar.png';
import logoEn from '../../../img/iga/noel/logo-avent-gourmand-en.svg';
import logoFr from '../../../img/iga/noel/logo-avent-gourmand-fr.svg';
import ptsIcon from '../../../img/iga/noel/pts_icon.svg';
import sceneIconEn from '../../../img/iga/noel/scene_icon_en.svg';
import sceneIconFr from '../../../img/iga/noel/scene_icon_fr.svg';

const propTypes = {
    tagline: PropTypes.string,
    subtitle: PropTypes.string,
    complete: PropTypes.bool,
    offer: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    tagline: null,
    subtitle: null,
    complete: true,
    offer: null,
    className: null,
};

function IgaNoelEmployeesSplash({ tagline, subtitle, offer, complete, className }) {
    const { locale } = useIntl();
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            <div className={styles.splash}>
                {tagline !== null ? <div className={styles.tagline}>{tagline}</div> : null}
                <div className={styles.logoContainer}>
                    <img
                        src={locale === 'fr' ? logoFr : logoEn}
                        className={classNames([styles.image, styles.logo])}
                        alt="L'avent gourmand"
                    />
                    {[...Array(4)].map((_, i) => (
                        <SparkleIcon
                            key={`sparkle-${i + 1}`}
                            className={classNames([styles.sparkle, styles[`sparkle${i + 1}`]])}
                        />
                    ))}
                </div>
                {subtitle !== null ? <div className={styles.subtitle}>{subtitle}</div> : null}
                {complete ? (
                    <img
                        src={calendar}
                        className={classNames([styles.image, styles.calendar])}
                        alt="L'avent gourmand"
                    />
                ) : null}
                <img
                    src={branch}
                    className={classNames([styles.image, styles.branch])}
                    alt="L'avent gourmand"
                />
            </div>
            {complete ? (
                <div className={styles.offers}>
                    <div className={styles.offer}>
                        <div className={styles.value}>
                            <FormattedMessage defaultMessage="$500" description="Offer value" />
                        </div>
                        <FormattedMessage
                            defaultMessage="worth of groceries to be won"
                            description="Offer label"
                        />
                    </div>
                    <div className={styles.offersInner}>
                        +
                        <div
                            className={classNames([
                                styles.inlineImgs,
                                { [styles[locale]]: locale !== null },
                            ])}
                        >
                            <img
                                src={ptsIcon}
                                className={classNames([styles.inlineImg, styles.pts])}
                                alt="pts"
                            />
                            <img
                                src={locale === 'en' ? sceneIconEn : sceneIconFr}
                                className={classNames([styles.inlineImg, styles.scene])}
                                alt="Scène"
                            />
                        </div>
                        <div className={styles.label}>{offer}</div>
                    </div>
                </div>
            ) : null}
        </div>
    );
}

IgaNoelEmployeesSplash.propTypes = propTypes;
IgaNoelEmployeesSplash.defaultProps = defaultProps;

export default IgaNoelEmployeesSplash;
